import { useEffect, useState } from 'react';
import '../../../css/SoccerTeamHomePage.css';
import ScheduleBox from '../../../components/ScheduleBox';
import RecentBox from '../../../components/RecentBox';
import RosterBox from '../../../components/RosterBox';
import PLsoccerLogos from '../../../assets/PLsoccerLogos';
import Record from '../../../components/Record';

const BurnleyHome = () => {
    const [isTeamFavorite, setIsTeamFavorite] = useState(false);
    const [starredPlayers, setStarredPlayers] = useState([]);
    const [favoritesLoaded, setFavoritesLoaded] = useState(false);

    const handleSaveFavorites = async (players = starredPlayers, teamFav = isTeamFavorite) => {
        const filteredPlayers = players.filter(playerKey => playerKey.startsWith("Burnley"));
        
        const fav = {
            teamName: "Burnley",
            teamLogo: PLsoccerLogos["Burnley"],
            isTeamFavorite: teamFav,
            players: filteredPlayers.map(player => ({
                name: player,
                isFavorite: true
            }))
        };

         try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/favorites/save`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify(fav),
            });

        } catch(err) {
            console.error("Error saving favorites: ", err);
        }
    };

    useEffect(() => {
        const fetchFavorites = async () => {
            try {
                    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/favorites/get?team=Burnley`, {
                    headers: { "Content-Type": "application/json" },
                    credentials: "include",
                });
    
                if (!res.ok) {
                    console.log("No favorites found or error fetching");
                    setFavoritesLoaded(true);
                    return;
                }
                const data = await res.json();
    
                // highlight team star
                setIsTeamFavorite(data.team?.isFavorite || false);
    
                // highlight player stars
                const playerKeys = data.players
                    .filter(p => p.isFavorite && p.name.startsWith("Burnley"))
                    .map(p => p.name);  
                setStarredPlayers(playerKeys);
                setFavoritesLoaded(true);

            } catch (err) {
                console.error("Error fetching favorites", err);
            }
        };
    
        fetchFavorites();
    }, []);

    return (
        <div>
            <section className="soccer-top-row">
                <section className="soccer-team-info">
                    <img
                        className="soccer-team-logo"
                        src={PLsoccerLogos["Burnley"]}
                        alt="Burnley"
                    />
                    <div className="soccer-team-text">
                        <div className="soccer-title-row">
                            <h1>Burnley</h1>
                            <button
                                type="button"
                                className="soccer-favorite-btn"
                                onClick={() => {
                                    const newVal = !isTeamFavorite;
                                    setIsTeamFavorite(newVal);
                                    handleSaveFavorites(starredPlayers, newVal); 
                                }}
                                aria-label="Toggle favorite"
                            >
                                {isTeamFavorite ? '★' : '☆'}
                            </button>
                        </div>
                        <p><span className="soccer-label">Record:</span> <Record name="Burnley" /></p>
                        <p><span className="soccer-label">Stadium:</span> Turf Moor</p>
                        <p><span className="soccer-label">Head Coach / Manager:</span> Scott Parker</p>
                        <p><span className="soccer-label">Assistant Staff:</span> Henrik Jensen, Mike Jackson, Jonathan Hill, Jack Cork</p>
                    </div>
                </section>
            </section>

            <div className="soccer-team-content">
                <section className="soccer-left-content">
                    <h2>Roster</h2>
                    {favoritesLoaded && (
                    <RosterBox
                        teamName="Burnley"
                        sport="soccer"
                        favoritePlayers={starredPlayers || []} 
                        onFavoriteChange={(updatedPlayers) => {
                            setStarredPlayers(updatedPlayers);
                            handleSaveFavorites(updatedPlayers, isTeamFavorite);
                        }}
                    />
                    )}
                </section>

                <section className="soccer-middle-content">
                    <h2>Recent Matches</h2>
                    <RecentBox teamName="Burnley" />

                    <h2>Upcoming Matches</h2>
                    <ScheduleBox teamName="Burnley" />
                </section>

                <section className="soccer-right-content">
                    <h2>Fun Facts</h2>
                    <div className="soccer-box">
                        <p>• One of the founding members of the first English soccer leagues in 1888</p>
                        <br />
                        <p>• Their stadium, Turf Moor, has been their home since 1883, making it one of the longest-continuously used football stadiums in the world</p>
                        <br />
                        <p>• Are one of the only teams to win the top four English football leagues</p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default BurnleyHome;